var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentVerificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23279",
    "data-name": "Path 23279",
    d: "M7,7V3A1,1,0,0,1,8,2H21a1,1,0,0,1,1,1V16a1,1,0,0,1-1,1H17v3.993A1.006,1.006,0,0,1,15.993,22H3.007A1.006,1.006,0,0,1,2,20.993L2,8.007A1.006,1.006,0,0,1,3.01,7ZM9,7h6.993A1.006,1.006,0,0,1,17,8.007V15h3V4H9Zm6,2H4L4,20H15ZM8.5,18,4.967,14.464,6.381,13.05,8.5,15.172l4.242-4.243,1.414,1.414Z",
    transform: "translate(-2 -2)",
    fill: "#171e4a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentVerificationIcon);
export default __webpack_public_path__ + "static/media/document-verification-icon.69f49300154c52fd4702423366175858.svg";
export { ForwardRef as ReactComponent };